import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createCharityOrganization = (_, params) => {
    return Api(ENDPOINTS.CHARITY_ORGANIZATION.CREATE, params, requestType.POST);
};

const updateCharityOrganization = (id, params) => {
    return Api(ENDPOINTS.CHARITY_ORGANIZATION.UPDATE.replace(":id", id), params, requestType.PUT);
};

const getCharityOrganizationDetail = (id) => {
    return Api(`${ENDPOINTS.CHARITY_ORGANIZATION.SINGLE.replace(":id", id)}`, {}, requestType.GET);
};

const getAllCharityOrganizations = (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.search) queryParams.append("search", params.search);

    const finalUrl = queryParams.toString()
        ? `${ENDPOINTS.CHARITY_ORGANIZATION.GET_ALL}?${queryParams.toString()}`
        : ENDPOINTS.CHARITY_ORGANIZATION.GET_ALL;

    return Api(finalUrl, null, requestType.GET);
};

const getCharityOrganizationList = () => {
    return Api(ENDPOINTS.CHARITY_ORGANIZATION.GET_LIST, null, requestType.GET);
};



export {
    createCharityOrganization,
    updateCharityOrganization,
    getCharityOrganizationDetail,
    getAllCharityOrganizations,
    getCharityOrganizationList,
};
